import { useQuery } from '@tanstack/react-query';
import { useNotification } from '../../shared/notification/useNotification';
import { useTranslation } from 'react-i18next';
import { BehApiRoutes, behClient } from '../beh-api';

export interface SubmissionPickupTaskData {
  submissionId: string;
  destinationId: string;
  mandantId: string;
}

export interface ScheduledTaskExecution {
  taskName: string;
  id: string;
  executionTime: string;
  picked: boolean;
  consecutiveFailures: number;
  lastFailure: string | null;
  dataTypeTag: string;
  data: SubmissionPickupTaskData;
}

export const SUBMISSION_PICKUP_TASK_NAME = 'submission-pickup';

export function useScheduledTasks(taskNameFilter?: string) {
  const { notifyUserFromRequest } = useNotification();
  const { t } = useTranslation();

  return useQuery({
    queryKey: [
      BehApiRoutes.scheduledTasks(),
      BehApiRoutes.scheduledTasks(taskNameFilter)
    ],
    queryFn: () =>
      notifyUserFromRequest<Array<ScheduledTaskExecution>, unknown>(
        () => behClient.get(BehApiRoutes.scheduledTasks(taskNameFilter)),
        { errorMessage: t('api.error.scheduledTasks') }
      ),
    refetchOnMount: true,
    staleTime: 6_000
  });
}
